'use strict';

angular.module('internal.services')
    .directive('internalServiceActions', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'services/components/service-actions/service-actions.html',
            replace: true,
            controller: 'InternalActions'
        };
    }])
;